import { FormControl, InputLabel, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useRecoilStateLoadable } from 'recoil';
import { metrics } from '../../../recoil/selectors/metrics';

const useStyles = makeStyles((theme) => ({
  metricDropdown: {
    marginLeft: '1vw',
    marginTop: '10px',
  },
}));
export function MetricDropdown({ excludeMetricKeys, excludeGroups }) {
  const classes = useStyles();
  const [metricLoadable, setMetric] = useRecoilStateLoadable(metrics);

  function metricHandler(e) {
    const [title, key] = e.target.value.split(',');
    // console.log(split)
    setMetric({
      title,
      key,
    });
  }
  const defaults = [
    {
      title: 'All Connections',
      key: 'allconnections',
      groups: ['Connections'],
    },
    {
      title: 'Answered Calls',
      key: 'allanswered',
      groups: ['Total'],
    },
    {
      title: 'Missed Calls',
      key: 'allmissed',
      groups: ['Total'],
    },
    {
      title: 'Outgoing Calls',
      key: 'alloutgoing',
      groups: ['Outgoing'],
    },
    {
      title: 'Answered',
      key: 'outgoinganswered',
      groups: ['Outgoing'],
    },
    {
      title: 'Missed',
      key: 'outgoingmissed',
      groups: ['Outgoing'],
    },
    {
      title: 'Connections',
      key: 'outgoingconnection',
      groups: ['Outgoing'],
    },
    {
      title: 'Total Powerlist Dials',
      key: 'totalPowerlistDials',
      groups: ['Outgoing'],
    },
    {
      title: 'Incoming Calls',
      key: 'allincoming',
      groups: ['Incoming'],
    },
    {
      title: 'Answered',
      key: 'incominganswered',
      groups: ['Incoming'],
    },
    {
      title: 'Missed',
      key: 'incomingmissed',
      groups: ['Incoming'],
    },
    {
      title: 'Connections',
      key: 'incomingconnection',
      groups: ['Incoming'],
    },
    {
      title: 'Total Duration',
      key: 'tduration',
      groups: ['Duration'],
    },
    {
      title: 'Avg. Duration',
      key: 'allavgduration2',
      groups: ['Duration'],
    },
  ];
  const groupTypes = [
    'Connections',
    'Total',
    'Outgoing',
    'Incoming',
    'Duration',
  ].filter((group) => !excludeGroups?.includes(group));

  return (
    <FormControl
      className={classes.metricDropdown}
      size="small"
      variant="outlined"
    >
      <InputLabel>Metric</InputLabel>
      <Select
        defaultValue={
          metricLoadable.state === 'hasValue'
            ? `${metricLoadable?.contents?.current?.title},${metricLoadable?.contents?.current?.key}`
            : 'All Connections,allconnections'
        }
        native
        onChange={metricHandler}
        label="Metric"
        name="metric-dropdown"
      >
        {groupTypes.map((group) => (
          <optgroup key={group} label={group}>
            {defaults
              .filter((metric) => !excludeMetricKeys?.includes(metric.key))
              .filter((metric) => metric.groups.includes(group))
              .map((metric) => (
                <option
                  key={metric.key}
                  value={`${metric?.title},${metric?.key}`}
                >
                  {metric?.title}
                </option>
              ))}
          </optgroup>
        ))}
      </Select>
    </FormControl>
  );
}
